import type { Router } from "./router";
import { currentScope } from "./scope";

let activeRouter: Router | null = null;

/** Called once from main.ts after the router is created. */
export function wireUnsavedGuard(router: Router): void {
  activeRouter = router;
}

/** Guards both navigation styles against losing edits (Phase 2a item 11): SPA
 * navigation via the router's guard, and hard reloads/`location.assign`/tab-close via
 * `beforeunload`. Call inside a view's synchronous construction; everything unhooks via
 * the view's scope cleanup. Views that redirect after a successful save must make
 * `isDirty` return false first (e.g. reset the form / set a leaving flag). */
export function registerUnsavedGuard(isDirty: () => boolean): void {
  const onBeforeUnload = (event: BeforeUnloadEvent): void => {
    if (isDirty()) event.preventDefault();
  };
  window.addEventListener("beforeunload", onBeforeUnload);
  activeRouter?.guard(() => (isDirty() ? "You have unsaved changes. Leave anyway?" : true));
  currentScope().cleanup(() => {
    window.removeEventListener("beforeunload", onBeforeUnload);
  });
}
